import {defineMessages} from 'react-intl'

const messages = defineMessages({
    locale: 'hr',
    app_name: 'CS Orthoseminars Adria',
    sign_in: 'Prijavi se',
    sign_out: 'Odjavi se',
    username: 'Korisničko ime',
    password: 'Lozinka',
    about: 'O Nama',
    home: 'Naslovna',
    page_not_found: 'Stranica nije pronađena',
    settings: 'Postavke',
    theme: 'Tema',
    default: 'Zadano',
    red: 'Crvena',
    green: 'Zelena',
    language: 'Jezik',
    hr: 'Hrvatski',
    en: 'Engleski',
    de: 'Njemački',
    ru: 'Ruski',
    menu: 'Izbornik',
    menu_mini_mode: 'Mini menu',
    offline: 'Izvan mreže',    
    helmet_description: 'CS Orthoseminars ADRIA - Seminari za sve doktore dentalne medicine sažeti u 9 modula!',
    helmet_keywords: 'ortodontski seminari, seminari, seminari za zubare, seminari za stomatologe, seminari za dentalnu medicinu, csorthoseminars, adria seminari, edukacija, ortodoncija, csorthoseminars adria, stomatologija, stomatolog, zubar, kirurgija, maksilofacijalna, maksilofacijalna kirurgija, aparatić, bravica, speova krivulja, dental, specijalizacija, stomatološka ordinacija, cso-adria, cso, common sense, hrvatska komora dentalne medicine, hkdm',
        

    // ############ MENU SEKCIJA #######################
    menu_home: 'Naslovna',
    menu_back: 'Natrag',
    menu_seminar_content: 'Sadržaj seminara',
    menu_register: 'Prijava',
    menu_instructor: 'Predavač',
    menu_FAQ: 'FAQ',
    menu_team: 'Tim',
    menu_testimonial: 'Klijenti o nama',
    free_entrance: 'Besplatno',
    modules9_days19: '9 Modula / 19 Dana',
    module_1: 'Modul 1',
    module_2: 'Modul 2',
    module_3: 'Modul 3',
    module_4: 'Modul 4',
    module_5: 'Modul 5',
    module_6: 'Modul 6',
    module_7: 'Modul 7',
    module_8: 'Modul 8',
    module_9: 'Modul 9',

    footer_menu_terms_and_conditions: 'Opći uvjeti poslovanja',
    footer_menu_privacy: 'Politika privatnosti',
    footer_menu_impressum: 'Impresum',
    discount_early_registration_sarajevo_series_2: 'Popust za prijave do 06.03.2023',
    discount_early_registration_sarajevo_series_2_details: '800 KM popust za prijave do 06.03.23.',

    discount_early_registration_sarajevo_serie_3: 'Popust za prijave do 10.09.2024',
    discount_early_registration_sarajevo_serie_3_details: '800 KM popust za prijave do 10.09.2024',

    terms_and_use_title: 'Opći uvjeti poslovanja',
    privacy_policy_title: 'Politika privatsnost',

    // ############ COURSE CONTENT SECTION #######################
    
    course_content_title: 'Ortodoncija iz naše prakse za Vašu praksu',
    course_content_subtitle: 'Zašto odabrati nas?',
    course_content_600: 'Dokumentiranih slučajeva',
    course_content_40000: 'Stranica informacija',
    course_content_25: 'Animiranih videa',
    course_content_50: 'Video vizualizacija',

    //################# SEMINAR DATE ###################################

    date_seminar_intro_sarajevo_2022: '07.05.2022 16h - 19h',
    date_seminar_intro_zagreb_2022: '10.09.2022 16h - 19h',
    date_seminar_series_sarajevo_1: '27.05.2022 - 08.07.2023',
    date_seminar_series_zagreb_5: '07.10.2022 - 27.10.2023',

    discount_early_registration_sarajevo_series_1: '-',//'800 KM popust za prijave do 10.05.22',
    discount_early_registration_sarajevo_series_4: '800 KM popust za prijave do 31.07.2025',
    discount_early_registration_zagreb_series_5: '-', //'3000 KN popust za prijave do 24.07.2022',
    discount_early_registration_zagreb_series_6: '400 € popust za rane prijave do 24.09.2023',
    discount_early_registration_zagreb_series_7: '400 € popust za rane prijave do 11.06.2024',
    discount_early_registration_zagreb_series_8: '400 € popust za rane prijave do 31.07.2025',

    //################ SEMINAR AND HOTEL NAME #####################################

    name_intro_seminar: 'Besplatni INTRO Seminar',
    series_name: ' Serija seminara - Sarajevo',

    seminar_name_sarajevo_intro: 'Intro seminar - Sarajevo',
    seminar_description_sarajevo_intro: 'Hotel "Hills", Butmirska cesta 18, Ilidža 71210, BiH',

    seminar_name_sarajevo_serie_1: '1. Serija seminara - Sarajevo',
    seminar_description_sarajevo_serie_1: 'Hotel "Hills", Butmirska cesta 18, Ilidža 71210, BiH',

    seminar_name_sarajevo_serie_2: '2. Serija seminara - Sarajevo',
    seminar_description_sarajevo_serie_2: 'Hotel "Hills", Butmirska cesta 18, Ilidža 71210, Bosna i Hercegovina',

    seminar_name_sarajevo_serie_3: '3. Serija seminara - Sarajevo',
    seminar_description_sarajevo_serie_3: 'Hotel "Hills", Butmirska cesta 18, Ilidža 71210, Bosna i Hercegovina',

    seminar_name_sarajevo_serie_4: '4. Serija seminara - Sarajevo',
    seminar_description_sarajevo_serie_4: 'Hotel "Hills", Butmirska cesta 18, Ilidža 71210, Bosna i Hercegovina',

    seminar_name_zagreb_intro: 'Intro seminar - Zagreb',
    seminar_description_zagreb_intro: 'Hotel "International", Miramarska Cesta 24, 10000, Zagreb, Hrvatska',

    seminar_name_zagreb_serie_5: '5. Serija seminara - Zagreb',
    seminar_description_zagreb_series_5: 'Hotel "International", Miramarska Cesta 24, 10000, Zagreb, Hrvatska',

    seminar_name_zagreb_serie_6: '6. Serija seminara - Zagreb',
    seminar_description_zagreb_series_6: 'Hotel "International", Miramarska Cesta 24, 10000, Zagreb, Hrvatska',

    seminar_name_zagreb_serie_7: '7. Serija seminara - Zagreb',
    seminar_description_zagreb_series_7: 'Hotel "International", Miramarska Cesta 24, 10000, Zagreb, Hrvatska',

    seminar_name_zagreb_serie_8: '8. Serija seminara - Zagreb',
    seminar_description_zagreb_series_8: 'Hotel "International", Miramarska Cesta 24, 10000, Zagreb, Hrvatska',

    seminar_name_sarajevo_intro_2024: 'Intro seminar - Sarajevo',
    seminar_description_sarajevo_intro_2024: 'Hotel "Hills", Butmirska cesta 18, Ilidža 71210, Bosna i Hercegovina',

    //################ INTRO SEMINAR ####################################
    
    content_intro_1: 'Besplatan Intro seminar',
    content_intro_2: 'Hrana i piće',
    content_intro_3: 'Dinamična atmosfera',
    content_intro_4: 'Primjeri iz prakse',
    content_intro_5: 'Vaši prvi ortodontski koraci',
    content_button: 'Prijavi se',
    waiting_list: 'Lista čekanja',
    sold_out: 'POPUNJENO',
    submit_on_waiting_list: 'LISTA ČEKANJA',
    info_prices: 'Info & Cijene',
    only_info: 'Info',

    //############## SEMINAR SERIES ################################

    content_series_1:'9 Modula / 19 dana',
    content_series_2:'Hrana i piće',
    content_series_3:'Dinamična atmosfera',
    content_series_4:'Primjeri iz prakse',
    content_series_5:'Radni materijali i skripte',
    content_rs_komora_info: 'Komora dr. stom. Republike Srpske dodjeljuje 54 boda svojim članovima',

    // ############### BENEFITS SECTION #########################
    
    benefits_title: 'Benefiti seminara',
    benefits_subtitle: 'Koje su prednosti za ...',
    benefits_doctor: '...Vašu ordinaciju',
    benefits_patient: '...Vaše pacijente',
    benefit_ord_1: 'Unaprijedite rad u Vašoj ordinaciji sa širim poljem djelovanja',
    benefit_ord_2: 'Nakon seminara ćete steći visoki stupanj znanja s kojim možete izvesti uspješnu ortodontsku terapiju u Vašoj ordinaciji',
    benefit_ord_3: 'Otkrivamo Vam naše cjelokupno iskustvo i stručnost stečeno tijekom dugogodišnjeg ortodontskog rada',
    benefit_ord_4: 'Prikazujemo Vam naše uspjehe ali i neuspjehe, nastojeći precizno objasniti kako ih Vi možete izbjeći u Vašem radu',
    benefit_ord_5: 'Dobit ćete popis određenih materijala i instrumenata koji su Vam potrebni za ortodontsku ordinaciju',
    benefit_ord_6: 'Nakon seminara nećete biti prepušteni sami sebi , te nam se možete obratiti ako trebate daljnju podršku',
    benefit_pat_1: 'Temporomandibularne poremećaje u 95% slučajeva možete riješiti  ortodoncijom',
    benefit_pat_2: 'Korekcija zagriza - križni zagriz, otvoreni zagriz, škarasti zagriz, asimetrija, zbijenost, rastresitost, impaktirani zubi',
    benefit_pat_3: 'Podarite ponovno lijepi osmijeh Vašim pacijentima',
    benefit_pat_4: 'Ortodoncija pomaže Vašim pacijentima kod teškoća u govoru',
    benefit_pat_5: 'Ortodoncijom smanjite rizik od traumatskih oštećenja zubi',

    // ############ TEAM SECTION #######################
    
    team_violeta_bio: "Već dugi niz godina organizatorica seminara, nadzor i podrška za polaznike seminara, instruktor tečaja za ortodontsko treniranje asistenata, preko 20 godina rada na pacijentima i iskustva u ortodonciji, voditelj tima, CS Orthoseminars i CCO diploma.",
    team_robert_bio: "Dr. Robert Scherngell, magistar znanosti se uspješno bavi ortodoncijom već preko 25 godina. Također predaje po cijelom svijetu preko 10 godina. Održao je seminare u Europi, Australiji, Aziji te Americi. Njegova napredna serija seminara pruža visoku razinu znanja od početničke do napredne razine. Uspješno je tretirao preko 6000 pacijenata u svoje dvije ordinacije u Austriji. Član je Austrijsko odbora ortodonata (ABO), Europskog društva ortodonata te ima magisterij iz ortodoncije sa Sveučilišta u Kremsu, Austriji. ABO ispit položio u ožujku 2009 - Magistar ortodoncije postaje u ožujku 2009, Sveučilište u Kremsu -Član: Europskog društva ortodonata - Verband Österreichischer Kieferorthopäden - Austrijske komore dentalne medicine -Obrazovanje: Dentistry of the Dental Medical Association, Austria - Orthodontics of the Dental Medical Association, Austria",
    team_iva_bio: "Nakon završene matematičke gimanzije u Imotskom upisuje studiji Dentalne medicine u Splitu kojeg završava 2012. godine. Odmah po završetku studija zapošljava se u ordinaciji dentalne medicine dr. Mirko Bušić u Puli, gdje stječe sveobuhvatno znanje iz područja dijagnostike, kirurgije, implantologije, protetike, estetske dentalne medicine, zubne tehnike te cjelokupnog menadžmenta ordinacije. 2017. godine otvara svoju privatnu praksu u Splitu koju vodi i danas. Tijekom svih godina usavršava se na mnogim domaćim i međunarodnim kongresima, posebno iz područja digitalno navođene implantologije, digitalne protetike. Motivirana rješavanjem pretprotetskih ortodontskih slučajeva završava CS Orthoseminars 2019. godine. U želji da prenese vlastito iskustvo i znanje od 2018. godine je vanjski stručni suradnik na Studiju dentalne medicine, Medicinski fakultet Split. Izvanredni ortodontski rezultati te zavidno znanje i stručnost prepoznati su od strane dr. Scherngella, te se sukladno tome 2022. godine pridružuje CS Ortoseminars timu kao predavač za područje cijele Hrvatske.",
    team_dalibor_bio: "Završio je srednju zubotehničku školu među najboljim u generaciji. Usavršavao se u Parizu u izradi protetskih radova nakon čega upisuje Stomatološki fakultet Univerziteta u Sarajevu. Bio je člana odbora Udruženja stomatologa FBiH. 12 godina uspješne  prakse u suradnji sa specijalistima svih grana stomatologije. Trenutno je na završnoj godini specijalizacije iz ortodoncije u Sarajevu. CS Orthoseminars završio je u Zagrebu sa izvrsnim rezultatima te se od tada intenzivno priprema za predavača CS Orthoseminara!",
    team_guest_speaker: 'Gostujući predavač',
    team_seminar_speaker: 'Predavač',
    team_founder: 'Osnivač',
    team_seminar_organisator: 'Organizator seminara',
    our_team_member: 'Naš tim',
    meet_our_perfectionist: 'Upoznajte naše perfekcioniste',
  
    // ############ FAQ SECTION #######################
    
    faq_title: 'Često postavljena pitanja (FAQ)',
    faq_subtitle: 'Vi imate pitanje. Mi imamo odgovor.',

    // ############ CLIENT FEEDBACK #######################
    
    client_feedback_title: 'Feedback',
    client_feedback_subtitle: 'Što naši klijenti kažu o nama',
    testimonial_suzana_designation: 'dr.med.dent. Split, Hrvatska',
    testimonial_suzana_comment: 'Bilo mi je veliko zadovoljstvo prisustvovati na CS Orthoseminarsima. Program seminara Dr. Robert Scherngella je potpuno promijenio moj način razmišljanja i po prvi put osjećam da razumijem ortodonciju!',
    testimonial_aida_designation: 'dr.med.dent. Sarajevo, Bosna i Hercegovina',
    testimonial_aida_comment: 'CS Orthoseminars je odličan niz seminara koju možete iskoristiti u svakodnevoj praksi. Predavanja su intenzivna, osmišljena da kroz module shvatite ortodonciju na najbolji mogući način. Team CS Orthoseminarsa će vam u sklopu seminara prenijeti nesebično svoje znanje i vještine.',
    testimonial_tamara_designation: 'dr.med.dent. Zagreb, Hrvatska',
    testimonial_tamara_comment: 'Završila sam CS ortho program koji se sastojao od 9 modula. Moduli su dobro strukturirani i sadrže sve za uspješan početak rada u ortodonciji. Uz podršku CS tima koji su tu za svako vaše pitanje osjećala sam se sigurnije. Veliko hvala CS timu sto su nam otkrili tajne ortodoncije i nesebično podijelili svoja znanja!',
    testimonial_eva_designation: 'dr.med.dent. Ljubljana, Slovenija',
    testimonial_eva_comment: 'Svakim danom radujem se svojim ortodontskim pacijentima i sve boljoj kvaliteti života koju doživljavaju kroz ortoterapiju. Svim kolegama zainteresiranim za ortodonciju preporučila bih seriju tečajeva CS Orthoseminars i njihov tim koji velikodušno i vrlo sustavno prenose svoje znanje. Na sva pitanja, tijekom i nakon tečaja, odgovaraju vrlo brzo kako nitko ne bi ostao sam u slučaju komplikacija.',
    testimonial_matea_designation:'dr.med.dent. Rijeka, Hrvatska',
    testimonial_matea_comment: 'Osim odlične organizacije i znanja koje sam stekla, jako sam zahvalna CS Ortho timu na njihovoj predanosti i dostupnosti kako za vrijeme trajanja seminara tako i nakon njegova završetka, bilo to brzim odgovorima putem e-maila, viber grupe ili telefonskim pozivima. Hvala na svemu! Jako mi je drago sto sam bila dio ovog cijelog Master putovanja.',
    testimonial_diana_designation: 'dr.med.dent. Glina, Hrvatska',
    testimonial_diana_comment: 'Želite li unaprijediti svoj rad i rad ordinacije, svakako to učinite sa timom CS ortho seminar. Hvala Violeti i dr. Scherngellu na znanju i podršci.',
    testimonial_ante_designation: 'dr.med.dent. Split, Hrvatska',
    testimonial_ante_comment: 'CS Orthoseminars ispunio je sva moja očekivanja jer sam kroz seminare dobio potrebna znanja i vještine da se mogu uspješno uputiti u svijet ortodoncije. Cijeli proces praćen je izvanrednim supportom tako da je ortodontska terapija vođena na ovaj način jednostavno osuđena na uspjeh.',
    testimonial_anica_plamenac_designation: 'dr.stom. Podgorica, Crna Gora',
    testimonial_anica_plamenac_comment: 'Seminari kroz module sažimaju sve najvažnije aspekte ortodoncije. Tim CS Orthoseminars nesebično dijeli svoje viještine kao i podršku za rješavanje svih slučajeva sa kojima se susrećemo u svojoj praksi. Toplo preporučujem CS Orthoseminars svim svojim kolegama.',


    // ############ CLIENT FEEDBACK #######################
    
    registration_title: 'Prijavite se',
    registration_subtitle: 'Brzo i jednostavno',

    //########PERSON
    
    person_tos_checkbox: 'Prihvaćam Politiku privatnosti i ',
    person_opce_uvjete_poslovanja: 'Opće uvjete poslovanja',
    person_additional_info: 'Dodatne informacije',
    person_country: 'Država',
    person_postal: 'Poštanski broj',
    person_city: 'Grad',
    person_street_number: 'Broj',
    person_street: 'Ulica',
    person_ordination: 'Ordinacija',
    person_phone: 'Telefon',
    person_email: 'Email',
    person_last_name: 'Prezime',
    person_first_name: 'Ime',
    person_title: 'Titula',
    seminar_register: 'Pošalji prijavu!',
    address: 'Adresa',

    // ############### PAYMENT REGISTRATION BLOCK
    
    payment_type_title: 'Način plaćanja',
    payment_type_free: 'Besplatno',
    payment_total: 'Uplata u cijelosti',
    payment_partial_down: 'Djelomično plaćanje (3 rate)',
    payment_partial_modules: 'Djelomično plaćanje (9 rata)',
    required: 'Obvezno polje *',
    wrong_email: 'Unesena Email adresa nije ispravna',
    payment_type_total_info: 'Ako se cjelokupna kotizacija uplati najkasnije 14 dana prije početka seminara (Modul 1), bit će odobren popust od 10% kotizacije.',
    payment_type_partial_down_info: 'Ako se odabere opcija djelomičnog plaćanja u 3 rate, odobrava se popust od 5% kotizacije.',
    payment_type_partial_down_info_1: '1. Rata: najkasnije 14 dana prije modula 1 /',
    payment_type_partial_down_info_2: '2. Rata: najkasnije 14 dana prije modula 3 /',
    payment_type_partial_down_info_3: '3. Rata: najkasnije 14 dana prije modula 5 /',
    payment_type_partial_modules_info: 'Ukoliko se odabere opcija djelomičnog plaćanja (9 rata), plaća se cjelokupna cijena seminara bez dodatnog popusta.',
    payment_type_partial_modules_info_1: '1. 3. 4. 5. 6. 7. 8. 9. Rata: najkasnije 14 dana prije modula /',
    payment_type_partial_modules_info_2: '2.Rata (3 dana): najkasnije 14 dana prije modula /',

    caution_is_required_text: 'Kaucija od 500€ je obvezna i predstavlja sredstvo potvrde Vašeg sudjelovanja na seminaru, a mora biti uplaćena najkasnije 14 dana od primitka obavijesti o registraciji na seminar. Za više informacija posjeteite ',

    // ############### SUBMIT INFO
    
    submit_error_happens: 'Dogodila se pogreška!',
    submit_try_again: 'Molimo pokušajte ponovno ili nas kontaktirajte.',
    submit_success_headline: 'Prijava je uspješno poslana!',
    submit_success_subText: 'Potvrda o prijavi Vam je poslana na Email adresu. Hvala Vam na ukazanom povjerenju!',
    submit_please_wait: 'Molimo pričekajte!',
    submit_ok: 'U redu',

    query_success_headline: 'Upit je uspješno poslan!',
    query_success_subText: 'Javit ćemo se na navedene kontakt podatke što je prije moguće. Hvala Vam na ukazanom povjerenju!',

    cookies_text: 'Ova web stranica koristi "kolačiće" kako bi poboljšati korisničko iskustvo. Za više informacija pročitajte našu ',
    cookies_privacy_policy: 'Politiku privatnosti',

    // Seminar CONTENT
    
    info_seminar_content_heading: "“Ortodoncija za početnike i napredne sažeto u 9 modula”",
    info_seminar_content_description: "Zašto biste trebali učiti „zdravim razumom“? Common Sense Orthoseminari su osnovani na preko 28 godina iskustva Dr. Roberta Scherngella sa 6.000+ uspješnih ortodontskih terapija. Program seminara je praktičan, nekompliciran te popraćen brojnim video zapisima i animacijama.",

    banner_eight_discount: "10% Popusta",
    banner_single_payment: "na jednokratno plaćanje",
    banner_register_sarajevo: "3000 KN popust za prijave do 24.07.2022",
    banner_orthodontic_seminars: "Ortodontski seminari",

    // call_to_action_heading: "“Praktično i logično kroz ortodonciju”",
    cs_slogan: "Praktično i logično kroz ortodonciju!",
    call_to_action_heading: "Zatraži ponudu u samo 2 koraka...",
    call_to_action_alt_title: "“Praktično i logično kroz ortodonciju”",
    call_to_action_contact: "DO PONUDE!",
    // call_to_action_contact: "KONTAKTIRAJTE NAS",

    email_seminar_price: "Cijena",
    email_seminar_title: "Uspješno ste se prijavili na seminar",
    email_additional_info: "Dodatne informacije",
    email_date: "Datum",
    email_success: "Vaša prijava je uspješno zaprimljena!",
    email_seminar_duration_per_day: "Seminari se održavaju od 09:30h do 17:00 h",
    email_seminar_tax_hr: 'sa uklj. 25% PDV',
    email_seminar_tax_bih: 'sa uklj. 17% PDV',

    go_to_sign_up: 'Prijavite se',
    sign_up_to_the_waiting_list: 'Prijavite se na listu čekanja',
    included_in_the_price: 'Uključeno u cijenu',
    price: "Cijena",
    choose_payment_type: "Odaberite način plaćanja",

    obligatory_regisration_title: "Obvezna prijava",
    waiting_list_registration_title: "Prijava na listu čekanja za iduću seriju",
    waiting_list_registration_title_email: "Prijava na listu čekanja za ",

})

export default messages
